export const contractAddress = "0x8F9dDa69720a0D857Da1122b983c033A5d6a6483";
export const tokenAddress = "0x9460802a8a65B3de37F0D93539Ffdb57BBf52BF2";
